export default IconTrafficCone => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-traffic-cone" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 20l16 0" />
  <path d="M9.4 10l5.2 0" />
  <path d="M7.8 15l8.4 0" />
  <path d="M6 20l5 -15h2l5 15" />
</svg>`;